import { action, observable, makeObservable } from 'mobx';
import {CurrentUserResponse} from '../../../domain';
import {TimeZone} from '../../../domain/models/timezone';
import {logger} from '../misc/logger';
import {isNullOrUndefined} from '../types/isNullOrUndefined';

const defaultTimeZone: TimeZone = {
  Id: -1,
  UtcOffsetMinutes: 0,
  Name: 'Local Time Zone',
  UtcName: 'UTC+0 Local Time Zone'
};


class CurrentTimeZoneStore {
  @observable
  utcOffsetMinutes = defaultTimeZone.UtcOffsetMinutes;
  @observable
  timeZone: TimeZone = defaultTimeZone;
  @observable
  driftSeconds: number = 0;

  constructor() {
    makeObservable(this);
  }

  @action
  update(response: CurrentUserResponse) {
    const timeZone = response?.User?.TimeZone;
    if (isNullOrUndefined(timeZone))
      return;
    this.timeZone = timeZone;
    this.utcOffsetMinutes = timeZone.UtcOffsetMinutes;
    const now = Date.now() / 1000;
    this.driftSeconds = Math.round(now - response.ServerTime);
  }
}

export const currentTimeZoneStore = new CurrentTimeZoneStore();

export function currentTimeZone(): TimeZone {
  return currentTimeZoneStore.timeZone;
}
